import type { SurchargeField } from './types';

export const SURCHARGE_FIELDS: Array<SurchargeField> = [];
